<!-- <div ng-class="{'is-required': vm.required, 'is-disabled': vm.disabled}"> -->
<div [class.is-required]="required"
     [class.is-disabled]="disabled"
     [class.is-invalid]="!validation.isHidden">
    @if (label) {
    <label class="label block m-b-2">{{label}}@if(required) {<span class="col-2">*</span>}</label>
    }

    <ng-content></ng-content>

    <validation [attr.cy-input-validation]="label"
                [messages]="messages"
                [canShow]="!!canShowValidate"
                #validation></validation>
</div>
